export class NotSupportedLevelError extends Error {
  constructor(level: string) {
    super(`Level ${level} not supported`);

    Object.setPrototypeOf(this, new.target.prototype);
  }
}
